import { render } from "./ModalMedPersonal.vue?vue&type=template&id=edcc6c3c"
import script from "./ModalMedPersonal.vue?vue&type=script&lang=js"
export * from "./ModalMedPersonal.vue?vue&type=script&lang=js"

import "./ModalMedPersonal.vue?vue&type=style&index=0&id=edcc6c3c&lang=css"

import exportComponent from "D:\\DEV\\Actual\\SanElita\\elita_web_site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__